const genSVG=(id,width,height,viewbox,listid,datanamelist,dlist,filllist,translist)=>{
    return(
        <svg id={id} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewbox}>
            {listid.map((item,index)=>(
                <path key={index} id={item} data-name={datanamelist[index]} d={dlist[index]} fill={filllist[index]}  transform={translist[index]}/>
            ))}
        </svg>
    )
}
const InstaSVG = () => {
    const listid = ["Trazado_3832", "Trazado_3833", "Trazado_3834"]
    const datanamelist = ["Trazado 3832", "Trazado 3833", "Trazado 3834"]
    const dlist = [
        "M24.514,0H9.343A9.354,9.354,0,0,0,0,9.343v15.17a9.354,9.354,0,0,0,9.343,9.343h15.17a9.354,9.354,0,0,0,9.344-9.343V9.343A9.354,9.354,0,0,0,24.514,0Zm6.34,24.514a6.347,6.347,0,0,1-6.34,6.339H9.343A6.346,6.346,0,0,1,3,24.514V9.343A6.347,6.347,0,0,1,9.343,3h15.17a6.347,6.347,0,0,1,6.34,6.339v15.17Z",
        "M49.692,40.97a8.724,8.724,0,1,0,8.724,8.724A8.734,8.734,0,0,0,49.692,40.97Zm0,14.444a5.72,5.72,0,1,1,5.72-5.72A5.726,5.726,0,0,1,49.692 55 414Z",
        "M121 124 28 251 a2 2 1 558 645 A2 212 2 212 28 251 Z"
    ]
    const filllist = ["#006", "#006", "#006"]
    const translist = ["", "translate(-32.764 -32.765)", "translate(-95.105 -22.593)"]
    return (
        genSVG(
        "logotipo-de-instagram",
        "33.857", "33.857",
        "0 0 33.857 33.857",
        listid, datanamelist, dlist, filllist,translist))


}
const FaceSVG=()=>{
    const listid = ["f_1_"]
    const datanamelist = ["f_1_"]
    const dlist = [
        "M48.7,33.857V18.414h5.181l.777-6.02H48.7V8.551c0-1.742.482-2.93,2.983-2.93h3.185V.236A43.189,43.189,0,0,0,50.229,0c-4.6,0-7.742,2.8-7.742,7.955v4.439h-5.2v6.02h5.2V33.857Z"
    ]
    const filllist = ["#006"]
    const translist = ["translate(-37.29)"]
    return (genSVG(
        "simbolo-de-la-aplicacion-de-facebook",
        "17.581", "33.857",
        "0 0 17.581 33.857",
        listid, datanamelist, dlist, filllist,translist))
}
const YoutubeSVG=()=>{
    const listid=["Trazado_3835","Trazado_3836"]
    const datanamelist=["Trazado_3835","Trazado_3836"]
    const dlist=[
        "M16.8,2c1.075,0,10.577.019,13.234.667l.044.012a5.444,5.444,0,0,1,3.79,3.907q.01.04.018.082a44.994,44.994,0,0,1,.712,8.242,44.994,44.994,0,0,1-.712,8.118q-.007.041-.018.082a5.444,5.444,0,0,1-3.79,3.907l-.017,0a42.959,42.959,0,0,1-7.725.647c-2.9.086-5.51.087-5.536.087s-2.64,0-5.536-.087a42.959,42.959,0,0,1-7.725-.647l-.007,0A5.431,5.431,0,0,1-.26,23.269q-.017-.059-.028-.12A44.989,44.989,0,0,1-1,14.907,44.99,44.99,0,0,1-.288,6.728q.007-.041.018-.082A5.444,5.444,0,0,1,3.52,2.739l.017,0a42.959,42.959,0,0,1,7.725-.647C14.158,2,16.772,2,16.8,2ZM29.417,5.088C27.379,4.6,19.624,4.5,16.8,4.5s-10.6.117-12.607.647A2.941,2.941,0,0,0,2.162,7.216,42.487,42.487,0,0,0,1.5,14.9s0,.009,0,.014a42.486,42.486,0,0,0,.66,7.723,2.951,2.951,0,0,0,2.027,1.97c2,.532,9.78.649,12.612.649s10.6-.117,12.607-.647a2.941,2.941,0,0,0,2.029-2.071,42.489,42.489,0,0,0,.664-7.628s0-.008,0-.012a42.49,42.49,0,0,0-.664-7.745A2.941,2.941,0,0,0,29.417,5.088Z"
        ,"M9,18.816A1.249,1.249,0,0,1,7.75,17.568V7.729A1.249,1.249,0,0,1,9.616,6.643l8.65,4.919a1.249,1.249,0,0,1,0,2.171l-8.65,4.919A1.248,1.248,0,0,1,9,18.816Zm1.249-8.941v5.545l4.875-2.773Z"
    ]
    const filllist=["#006","#006"]
    const translist = ["translate(1.001 -2)", "translate(5.414 0.26)"]
    return(
        genSVG(
            "youtube",
            "35.596", "25.756",
            "0 0 35.596 25.756",
            listid, datanamelist, dlist, filllist,translist
        )
    )
}


export {InstaSVG,FaceSVG,YoutubeSVG}